import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditLocationIcon from "@mui/icons-material/EditLocation";
import CancelIcon from "@mui/icons-material/Cancel";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import { Drawer, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import gpay from "../../../src/assets/Logo/google-pay.svg";
import paytm from "../../../src/assets/Logo/paytm.svg";
import phonepe from "../../../src/assets/Logo/phonepe.svg";
import razorpay from "../../../src/assets/Logo/razorpay1.svg";
import { editCartProduct, getCartProduct } from "../../Redux/CartRedux";
import { initiatePayment, placeOrder } from "../../Redux/OrderRedux";
import { getProductCount } from "../../Redux/ProductRedux";
import Address from "../Dashboard/Address/Address";
import { getAddressById } from "../../Redux/SellerRedux";

function Cart({ drawerOpen, handleDrawerClose }) {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [cartDetails, setCartDetails] = useState("");
  const [totalSubtotal, setTotalSubtotal] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteCart, setDeleteCart] = useState(false);
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const token = sessionStorage.getItem("accessToken");
  const user = JSON.parse(localStorage.getItem("user"));
  const { userAddress, defaultAddress } = useSelector(
    (state) => state.sellerRedux
  );

  const userId =
    localStorage.getItem("user") &&
    JSON.parse(localStorage.getItem("user")).userId;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (userAddress?.address?.length > 0) {
      const checkedAddress = userAddress.address.find((addr) => addr.isChecked);
      setSelectedAddress(checkedAddress);
    }
  }, [userAddress]);

  useEffect(() => {
    if (userId && drawerOpen) {
      setLoading(true);
      if (user.role === "buyer") {
        dispatch(getAddressById(user.userId));
      }
      dispatch(getCartProduct(userId))
        .then((result) => {
          if (result.status === "success") {
            let updatedCart = { ...result.cart };
            const quantityPromises = updatedCart.items.map(
              async (item, index) => {
                const productId = item._id;
                const priceId = item.priceAndQuantity[0]?._id;

                if (productId && priceId) {
                  const productCount = await dispatch(
                    getProductCount(productId, priceId)
                  );
                  if (item.Quantity > productCount.totalCount) {
                    item.Quantity = productCount.totalCount;
                  }
                }
              }
            );
            Promise.all(quantityPromises).then(() => {
              setCartDetails(updatedCart);
              const total = updatedCart.items.reduce((acc, item) => {
                const price = item.priceAndQuantity?.[0]?.price || 0;
                const quantity = item.Quantity || 1;
                return acc + price * quantity;
              }, 0);

              setTotalSubtotal(total);
            });
          } else {
            setCartDetails("");
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [drawerOpen]);

  const totalCalculation = () => {
    {
      const total = cartDetails?.items?.reduce((acc, item) => {
        const price = item.priceAndQuantity?.[0]?.price || 0;
        const quantity = item.Quantity || 1;
        return acc + price * quantity;
      }, 0);
      setTotalSubtotal(total);
      dispatch(editCartProduct(cartDetails));
    }
  };

  const increaseQuantity = (index) => {
    const updatedCart = [...cartDetails.items];
    const productId = updatedCart[index]._id;
    const priceId = updatedCart[index].priceAndQuantity[0]._id;
    dispatch(getProductCount(productId, priceId)).then((result) => {
      if (updatedCart[index].Quantity < result.totalCount) {
        updatedCart[index].Quantity = Number(updatedCart[index].Quantity) + 1;
        totalCalculation();
      }
    });
  };

  const decreaseQuantity = (index) => {
    const updatedCart = [...cartDetails.items];
    if (updatedCart[index].Quantity > 1) {
      updatedCart[index].Quantity = Number(updatedCart[index].Quantity) - 1;
      totalCalculation();
    }
  };

  useEffect(() => {
    const total = cartDetails?.items?.reduce((acc, item) => {
      const price = item.priceAndQuantity?.[0]?.price || 0;
      const quantity = item.Quantity || 1;
      return acc + price * quantity;
    }, 0);
    setTotalSubtotal(total);
    if (deleteCart) {
      dispatch(editCartProduct(cartDetails))
        .then((result) => {
          if (result.status === "success") {
            setDeleteCart(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [cartDetails]);

  const deleteCartItem = (index) => {
    setCartDetails((prevCartDetails) => {
      const updatedItems = prevCartDetails.items.filter((_, i) => i !== index);
      return { ...prevCartDetails, items: updatedItems };
    });
    setDeleteCart(true);
  };

  const shippingCost = 0;

  const checkOut = () => {
    const isOutOfStock = cartDetails.items.some((item) => item.Quantity === 0);
    if (isOutOfStock) {
      toast.error("Some items are out of stock please remove that ");
    } else {
      const { __v, _id, products, items, ...rest } = cartDetails;
      const updatedCart = {
        ...rest,
        shippingcost: shippingCost.toString(),
        subtotal: totalSubtotal.toString(),
        total: (totalSubtotal + shippingCost).toString(),
        deliveryaddress: selectedAddress,
        products: items?.map((item) => ({
          productId: item._id,
          productName: item.productName?.trim(),
          category: item.underCategory?.[0]?.category,
          quantity: item.Quantity,
          variant: item.priceAndQuantity?.[0]?.quantity,
          image: item.images?.[0]?.image,
          sellerId: item.createdBy,
          sellerName: item.sellerName,
          price: item.priceAndQuantity?.[0]?.price,
          status: "",
          newOrderAt: Date.now(),
        })),
      };
      const amt = (totalSubtotal + shippingCost).toString();
      setCartDetails(updatedCart);
      // dispatch(placeOrder(updatedCart))
      dispatch(initiatePayment(amt, userId, updatedCart))
        // dispatch(initiatePayment('1', 'c964634', 'first'))
        .then((result) => {
          if (result.status == "success") {
            setCartDetails("");
            handleDrawerClose(false);
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleLogin = () => {
    navigate("/account");
    handleDrawerClose();
  };

  const handleConfirmAddress = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    setOpen(false);
    setAddressConfirmed(true);

    // checkOut();
  };
  const isMobile = useMediaQuery("(max-width:600px)");

  if (loading) {
    return (
      <>
        <Drawer anchor="right" open={drawerOpen}>
          <div
            style={{
              width: isMobile ? "10vw" : 700,
              maxWidth: "100vw",
            }}
            role="presentation"
            //
            onKeyDown={handleDrawerClose}
          >
            <div
              className="p-4"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h4>Shopping Cart</h4>
              <span onClick={handleDrawerClose}>
                <CloseIcon />
              </span>
            </div>
            <div className="row mx-4">
              <div className="col-2 ">
                <Skeleton variant="rounded" height={75} />
              </div>
              <div className="col-8">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
              </div>
            </div>
            <div className="row mt-4 mx-4">
              <div className="col-2 ">
                <Skeleton variant="rounded" height={75} />
              </div>
              <div className="col-8">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
              </div>
            </div>
            <div className="row mt-4 mx-4">
              <div className="col-2 ">
                <Skeleton variant="rounded" height={75} />
              </div>
              <div className="col-8">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
  return (
    <>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerClose}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: 500, md: 700 },
            maxWidth: "100vw",
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          {/* Header */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography variant="h5" fontWeight={600}>
              Shopping Cart
            </Typography>
            {!isMobile && (
              <IconButton onClick={handleDrawerClose}>
                <CloseIcon />
              </IconButton>
            )}
          </Box>

          {/* Cart Table */}
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Item</TableCell>
                <TableCell>Product</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Price</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Subtotal</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cartDetails?.items?.length > 0 && token ? (
                cartDetails.items.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {item.images?.length > 0 && (
                        <img
                          src={`${BASE_URL}/assets/images/products/${item.images[0]?.image}`}
                          alt={item.productName}
                          style={{ width: 50, borderRadius: 4 }}
                        />
                      )}
                    </TableCell>
                    <TableCell>{item.productName}</TableCell>
                    <TableCell>
                      {item.priceAndQuantity?.[0]?.quantity || "0"}
                    </TableCell>
                    <TableCell>
                      ₹{item.priceAndQuantity?.[0]?.price || "0"}
                    </TableCell>
                    <TableCell>
                      {item.Quantity > 0 ? (
                        <Box display="flex" alignItems="center">
                          <IconButton
                            size="small"
                            onClick={() => decreaseQuantity(index)}
                          >
                            -
                          </IconButton>
                          <Typography sx={{ mx: 1 }}>
                            {item.Quantity}
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => increaseQuantity(index)}
                          >
                            +
                          </IconButton>
                        </Box>
                      ) : (
                        <Typography color="success.main">
                          Out of Stock
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      {item.Quantity > 0 &&
                        `₹${(
                          item.priceAndQuantity?.[0]?.price * item.Quantity
                        ).toFixed(2)}`}
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => deleteCartItem(index)}>
                        <DeleteIcon sx={{ color: "#C8102E" }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : !token ? (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Typography align="center">
                      Please login to continue
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Typography align="center">No items in the cart</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {/* Login Button */}
          {!token && (
            <Box textAlign="center" mt={4} display="flex" justifyContent="center" gap={3}>
              <Button
                variant="contained"
                color="success"
                onClick={handleLogin}
                sx={{ textTransform: "none", px: 4 }}
              >
                Login
              </Button>
             {isMobile &&( <Button
                variant="contained"
                color="error"
                onClick={handleDrawerClose}
                sx={{ textTransform: "none", px: 4 }}
              >
                Close
              </Button>)}
            </Box>
          )}

          {/* Summary Section */}
          {cartDetails?.items?.length > 0 && token && (
            <Box
              mt={5}
              mx="auto"
              sx={{
                maxWidth: 360,
                p: 3,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                boxShadow: 1,
                backgroundColor: "#fafafa",
              }}
            >
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography fontWeight={600}>Subtotal</Typography>
                <Typography>₹{totalSubtotal.toFixed(2)}</Typography>
              </Box>

              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  backgroundColor: "#e3f2fd",
                  border: "1px solid #90caf9",
                  borderRadius: "6px",
                  padding: "6px 10px",
                  width: "fit-content",
                }}
              >
                <InfoOutlinedIcon
                  style={{
                    fontSize: "25px",
                    color: "#1976d2",
                  }}
                />

                <Typography
                  style={{
                    fontSize: "14px",
                    color: "#0d47a1",
                    lineHeight: 1.4,
                  }}
                >
                  Delivery charges will be applicable separately
                </Typography>
              </Box>

              {/* <Box
                display='flex'
                justifyContent='space-between'
                mb={1}
              >
                <Typography fontSize={14}>Weight Based Shipping:</Typography>
                <Typography fontWeight={600}>
                  ₹{shippingCost.toFixed(2)}
                </Typography>
              </Box> */}

              {/* <Typography
                variant='body2'
                color='text.secondary'
                mb={2}
              >
                Shipping to <strong>Kerala</strong>
              </Typography> */}

              <Divider sx={{ my: 2 }} />

              <Box display="flex" justifyContent="space-between" mb={2}>
                <Typography fontWeight={700} color="success.dark" fontSize={18}>
                  Total
                </Typography>
                <Typography fontWeight={700} color="success.dark" fontSize={18}>
                  ₹{(totalSubtotal + shippingCost).toFixed(2)}
                </Typography>
              </Box>
              {defaultAddress && (
                <Box mb={2}>
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={1}
                  >
                    <Typography
                      fontWeight={700}
                      color="info.dark"
                      fontSize={15}
                      display="flex"
                      alignItems="center"
                    >
                      <LocalShippingIcon sx={{ mr: 1 }} /> Delivery Address
                    </Typography>

                    <Tooltip title="Change Address">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={handleConfirmAddress}
                      >
                        <EditLocationIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: "8px",
                      padding: "8px",
                    }}
                  >
                    <strong>{selectedAddress.homeName}</strong>
                    <br />
                    <strong>
                      {selectedAddress.doorNumber}, {selectedAddress.street}
                    </strong>
                    <br />
                    <strong>{selectedAddress.townOrCity}</strong>
                    <br />
                    <strong>{selectedAddress.pincode}</strong>
                    <br />
                    <strong>
                      {selectedAddress.state}, {selectedAddress.country}
                    </strong>
                    <br />
                  </Typography>
                </Box>
              )}
              <button
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  padding: "10px",
                  backgroundColor: "#d2d25b",
                  border: "2px solid #d2d25b",
                  borderRadius: "5px",
                  color: "#000",
                  fontWeight: "bold",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
                className="glitter-button"
                onClick={defaultAddress ? checkOut : handleConfirmAddress}
              >
                Proceed to checkout
              </button>
            </Box>
          )}
        </Box>
      </Drawer>
      <Dialog open={open}>
        <DialogTitle className="text-center">
          <div>
            <h5>Confirm Address</h5>
          </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            color: "black",
          }}
        >
          <CancelIcon />
        </IconButton>
        <DialogContent>
          <Address view="cart" />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSave} variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Cart;
